import { CookieMonster } from 'root/utils/cookies/cookieMonster';

interface TrackingUrlParamObject {
    utm_campaign?: string;
    utm_source?: string;
    utm_medium?: string;
    utm_content?: string;
    source?: string;
    mbsy?: string;
}

const rebuildLinkHref = (
    link: HTMLAnchorElement,
    newURLParams: TrackingUrlParamObject
) => {
    const oldURL = new URL(link.href);
    const URLParams = new URLSearchParams([
        ...Array.from(oldURL.searchParams.entries()),
        ...Object.entries(newURLParams),
    ]).toString();
    const newURL = new URL(
        `${oldURL.origin}${oldURL.pathname}?${URLParams}${oldURL.hash}`
    );
    link.href = newURL.href;
};

const getNewURLParams = (): TrackingUrlParamObject => {
    const cm = new CookieMonster();
    const UTMCampaign = cm.getCookie('campaignName');
    const UTMSource = cm.getCookie('campaignSource');
    const UTMMedium = cm.getCookie('campaignMedium');
    const UTMContent = cm.getCookie('campaignContent');
    const source = cm.getCookie('source');
    const ambassador = cm.getCookie('_ls-ambassador-referral');
    const domain = document.body.dataset.domain;
    const slug = domain ? `lshq_${domain}_ecom_form` : null;
    return {
        ...(UTMCampaign && { utm_campaign: UTMCampaign }),
        ...(UTMSource && { utm_source: UTMSource }),
        ...(UTMMedium && { utm_medium: UTMMedium }),
        ...(UTMContent && { utm_content: UTMContent }),
        ...(source && { source: source }),
        ...(ambassador && { mbsy: ambassador }),
        ...(slug && { slug: slug }),
    };
};

function populateESeriesLinkParams() {
    const eSeriesLinks = document.querySelectorAll<HTMLAnchorElement>(
        'a[href="https://ecom.lightspeed.app/cp/#register"]'
    );
    if (eSeriesLinks) {
        const newURLParams = getNewURLParams();
        if (Object.keys(newURLParams).length > 0) {
            eSeriesLinks.forEach(link => rebuildLinkHref(link, newURLParams));
        }
    }
}

export { populateESeriesLinkParams };
